import client from '@/shared/apis/client'
import { KasanHistoryResponse } from '@/apps/latest/features/guidance/types/kasanHistory'

export const fetchKasanHistory = async (
  yakurekiId: string
): Promise<KasanHistoryResponse> => {
  const { data } = await client.get<KasanHistoryResponse>(
    `/api/guidance-prep/kasan-history/${yakurekiId}/`
  )
  return data
}
